
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import Component from "vue-class-component";
import Vue from "vue";
import ApplicationsTable from "@/features/applications/components/ApplicationsTable.vue";
import EndorsementTable from "../components/EndorsementTable.vue";

@Component({
    components: {
        HeadingWave,
        ApplicationsTable,
        EndorsementTable
    }
})
export default class Endorsements extends Vue {
}
